import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";
import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";

import { KeyValue } from "@/main/models/common";
import { getTranslateByKey, isNullUndefined, isValueQueryParams } from "@/main/services/utils";

import { useDinamicFiltersMappingCodes } from "./dinamicFiltersMappingCodes";
import {
	getClaimFileCategory,
	resetReducerClaimFileCategory,
	useClaimFileCategoryReducer,
} from "@/main/store/claimFileCategory";

export const INITIAL_FORM_STATE_CLAIM_FILE_CATEGORY = {
	claimFileCategory: null as KeyValue | null,
};

export type IFormFiltersMappingTypeClaimFileCategory = typeof INITIAL_FORM_STATE_CLAIM_FILE_CATEGORY;

interface IFiltersMappingTypeClaimFileCategoryProps {}
function FiltersMappingTypeClaimFileCategory(_props: IFiltersMappingTypeClaimFileCategoryProps) {
	const dispatch = useDispatch();
	const { watcherCountry, isRequiredField } = useDinamicFiltersMappingCodes();
	const { claimFileCategory: claimFileCategoryReducer } = useClaimFileCategoryReducer();

	const { control, resetField, setValue } = useFormContext<IFormFiltersMappingTypeClaimFileCategory>();

	useEffect(() => {
		if (!isValueQueryParams(watcherCountry)) {
			resetField("claimFileCategory");
		}
		if (isNullUndefined(watcherCountry)) return;

		dispatch(getClaimFileCategory());

		return () => {
			dispatch(resetReducerClaimFileCategory());
		};
	}, [JSON.stringify(watcherCountry?.key)]);

	const disabledClaimFileCategory =
		isNullUndefined(claimFileCategoryReducer.data) || claimFileCategoryReducer.data.length === 1;

	return (
		<>
			<KogAutoCompleteControlled
				id="id-mappingCode-select-claimFileCategory"
				nameCustom="claimFileCategory"
				label={getTranslateByKey("information.claimFileCategory")}
				isDefaultValueUnique
				control={control}
				setValueCustom={setValue}
				options={claimFileCategoryReducer.data}
				isLoading={claimFileCategoryReducer.isLoading}
				disabled={disabledClaimFileCategory}
				rulesCustom={{ required: isRequiredField("claimFileCategory") }}
				onChangeCustom={() => {}}
			/>
		</>
	);
}

export default FiltersMappingTypeClaimFileCategory;
